module.exports = __webpack_public_path__ + "c5158958aa9e48aa41b561ea5fadb44b.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-icon.png
// module id = 353
// module chunks = 0